import { render, staticRenderFns } from "./MultipleDeptSelect.vue?vue&type=template&id=84793f68&scoped=true"
import script from "./MultipleDeptSelect.vue?vue&type=script&lang=js"
export * from "./MultipleDeptSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84793f68",
  null
  
)

export default component.exports